import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../BaseUrl";

const getToken = () => localStorage.getItem("ams_ecp");

// API headers including token
const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});
export const getCompanyDropdata = createAsyncThunk(
  "dept/getCompanyDropdata",
  async () => {
    try {
      const response = await BaseUrl.get(
        `/ecp/company/companyDropDown`,
        getAuthHeaders()
      );
      // console.log("response.data", response.data.data)
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      console.log(error);
    }
  }
);
export const getDeptDocdata = createAsyncThunk(
  "dept/getDeptDocdata",
  async (id) => {
    try {
      const response = await BaseUrl.get(
        `ecp/departmentDocs/allDocs/${id}`,
        getAuthHeaders()
      );
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      console.log(error);
    }
  }
);
export const createDeptDocdata = createAsyncThunk(
  "dept/createDeptDocdata",
  async (data) => {
    try {
      const response = await BaseUrl.post(
        `ecp/departmentDocs`,
        data,
        getAuthHeaders()
      );
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      console.log(error);
    }
  }
);
export const getAllDepdata = createAsyncThunk(
  "dept/getAllDeptdata",
  async () => {
    try {
      const response = await BaseUrl.get(`/ecp/department/`, getAuthHeaders());
      // console.log("response.data", response.data.data)
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      console.log(error);
    }
  }
);
export const createDeptdata = createAsyncThunk(
  "dept/createDeptdata",
  async (data) => {
    try {
      const response = await BaseUrl.post(
        `/ecp/department`,
        data,
        getAuthHeaders()
      );
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      console.log(error);
    }
  }
);
export const getSingleDeptdata = createAsyncThunk(
  "dept/getSingleDeptdata",
  async (id) => {
    try {
      // console.log("id====>>>", id);

      const response = await BaseUrl.get(
        `/ecp/department/${id}`,
        getAuthHeaders()
      );

      // console.log("response.data", response.data.data[0])
      return response.data.data[0];
    } catch (error) {
      // alert(`${error.response.data.message}`)
      console.log(error);
    }
  }
);
export const updateDeptdata = createAsyncThunk(
  "dept/updateDeptdata",
  async (data) => {
    try {
      const response = await BaseUrl.patch(
        `/ecp/department`,
        data,
        getAuthHeaders()
      );
      // console.log("response.data", response.data.data)
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      console.log(error);
    }
  }
);
export const getSingleDeptDoc = createAsyncThunk(
  "dept/getSingleDeptDoc",
  async (id) => {
    try {
      // console.log("id====>", id);
      const response = await BaseUrl.get(
        `/ecp/departmentDocs/${id}`,
        getAuthHeaders()
      );
      // console.log("company details===>", response.data)
      return response.data.data[0];
    } catch (error) {
      // alert(`${error.response.data.message}`)
      console.log(error);
    }
  }
);
export const updateDeptDocdata = createAsyncThunk(
  "dept/updateDeptDocdata",
  async (data) => {
    try {
      const response = await BaseUrl.patch(
        "/ecp/departmentDocs/",
        data,
        getAuthHeaders()
      );
      // console.log("company docs===>", response.data)
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      console.log(error);
    }
  }
);
export const createDeptSlice = createSlice({
  name: "createDept",
  initialState: {
    deptData: [],
    companyDropdata: [],
    deptDocdata: [],
    unicDeptdata: {},
    unicDeptdocdata: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllDepdata.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getAllDepdata.fulfilled, (state, action) => {
      state.loading = false;
      state.deptData = action.payload;
    });
    builder.addCase(getAllDepdata.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getCompanyDropdata.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getCompanyDropdata.fulfilled, (state, action) => {
      state.loading = false;
      state.companyDropdata = action.payload;
    });
    builder.addCase(getCompanyDropdata.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getSingleDeptdata.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getSingleDeptdata.fulfilled, (state, action) => {
      state.loading = false;
      state.unicDeptdata = action.payload;
    });
    builder.addCase(getSingleDeptdata.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getDeptDocdata.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getDeptDocdata.fulfilled, (state, action) => {
      state.loading = false;
      state.deptDocdata = action.payload;
    });
    builder.addCase(getDeptDocdata.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getSingleDeptDoc.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getSingleDeptDoc.fulfilled, (state, action) => {
      state.loading = false;
      state.unicDeptdocdata = action.payload;
    });
    builder.addCase(getSingleDeptDoc.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});
export const getDeptdata = (state) => state.createDept.deptData;
export const getDropDowndata = (state) => state.createDept.companyDropdata;
export const getDepartmentDocdata = (state) => state.createDept.deptDocdata;
export const getUnicDeptdata = (state) => state.createDept.unicDeptdata;
export const getUnicDeptDocdata = (state) => state.createDept.unicDeptdocdata;
export const loginerror = (state) => state.createDept.error;

export default createDeptSlice.reducer;
